import { FC } from 'react'
import { StackLayout } from '@progress/kendo-react-layout'
import { Input } from '@progress/kendo-react-inputs'
import { GeneralPurposeSearchItemSelect } from './GeneralPurposeSearchItemSelect'
import { GeneralPurposeSearchMethodSelect } from './GeneralPurposeSearchMethodSelect'

interface GeneralPurposeSearchProps {
  searchItem: string | undefined
  searchValue: string | undefined
  searchMethod: string | undefined
  onSearchItemChange: (valueList: string[]) => void
  onSearchValueChange: (value: string) => void
  onSearchMethodChange: (valueList: string[]) => void
  clear?: boolean
}

export const GeneralPurposeSearch: FC<GeneralPurposeSearchProps> = ({
  searchItem,
  searchValue,
  searchMethod,
  onSearchItemChange,
  onSearchValueChange,
  onSearchMethodChange,
  clear = false
}) => {
  return (
    <StackLayout orientation='horizontal'>
      <GeneralPurposeSearchItemSelect
        popupSettings={{ className: 'pcy-dropdownlist' }}
        value={searchItem !== undefined ? [searchItem] : undefined}
        onChange={onSearchItemChange}
        clear={clear}
      />
      &nbsp;は&nbsp;
      <Input
        value={searchValue}
        onChange={(e) => onSearchValueChange(e.value)}
      />
      <GeneralPurposeSearchMethodSelect
        popupSettings={{ className: 'pcy-dropdownlist' }}
        value={searchMethod !== undefined ? [searchMethod] : undefined}
        onChange={onSearchMethodChange}
        clear={clear}
      />
    </StackLayout>
  )
}
